import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const navList = [
    { name: 'Home', image: '/images/nav-icons/home1-50.png', url: '/', },
    { name: 'Services', image: '/images/nav-icons/icons8-shop-50.png', url: '/services', },
    { name: 'Projects', image: '/images/nav-icons/icons8-web-50.png', url: '/projects', },
    { name: 'About', image: '/images/nav-icons/icons8-badge-50.png', url: '/about', },
]


const Navbar = () => {

    const [open, setOpen] = useState(false)

    return (
        <header className='sticky top-0 z-50 pt-1 bg-transparent'>
        {/* <header className='sticky top-0 z-50 pt-1 bg-gradient-to-b from-black from-50% via-transparent via-50% to-transparent to-100%'> */}
            <nav className='flex items-center text-black py-2 px-4 justify-center'>
                <div className='flex justify-between items-center bg-blue-100/30 backdrop-blur overflow-hidden rounded-full pl-6'>
                {/* <div className='flex justify-between items-center bg-gradient-to-r from-blue-200/50 via-red-200/50 to-green-200/50 backdrop-blur overflow-hidden rounded-full pl-6'> */}
                    <Link to='/'>
                        <div className='flex items-end'>
                            <img src='/favicon4.ico' className='w-8 h-8 mr-4' />
                            <h1 className='hidden md:flex mr-4'>Syed Imad Ahmed</h1>
                        </div>
                    </Link>
                    {navList.map((page, key) => (
                        <Link to={page.url} key={key} className='hover:text-[#3fc07c] py-2 px-4 md:px-8'>
                            <img src={page.image} className='w-5 h-5 mx-auto' />

                            <h2 className='text-xs md:text-sm '>{page.name}</h2>
                        </Link>
                    ))}
                </div>
            </nav>
        </header>
    )
}

export default Navbar